<template>
    <div>
        <!-- 对话框 -->
        <el-dialog title="填写联系方式" :visible.sync="dialogVisible" width="400px" append-to-body>
            <!-- 表单 -->
            <el-form ref="contactForm" :model="form" :rules="rules" label-width="80px" size="small">
                <el-form-item label="QQ号" prop="qq">
                    <el-input clearable v-model="form.qq" placeholder="请输入QQ号" @keyup.enter.native="submitForm"/>
                </el-form-item>

                <el-form-item label="微信号" prop="wechat">
                    <el-input clearable v-model="form.wechat" placeholder="请输入微信号" @keyup.enter.native="submitForm"/>
                </el-form-item>

                <el-form-item label="邮箱" prop="email">
                    <el-input clearable v-model="form.email" placeholder="请输入邮箱" @keyup.enter.native="submitForm"/>
                </el-form-item>
            </el-form>

            <!-- 底部操作按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import { updateUserInfo } from '@/api/login/login';

export default {
    name: 'ContactDialog',
    data() {
        return {
            dialogVisible: false,
            form: {
                qq: '',
                wechat: '',
                email: '',
                tenantId: '000001',
                userId: '',
            },
            rules: {
                qq: [
                    { required: false, message: '请输入QQ号', trigger: 'blur' },
                    { pattern: /^[1-9][0-9]{4,11}$/, message: '请输入正确的QQ号', trigger: 'blur' }
                ],
                wechat: [
                    { required: false, message: '请输入微信号', trigger: 'blur' },
                ],
                email: [
                    { required: false, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '邮箱格式不正确', trigger: ['blur', 'change'] }
                ]
            }
        };
    },

    mounted() {

    },

    methods: {
        openDialog(userId) {
            this.form.userId = userId;
            this.dialogVisible = true;
        },
        submitForm() {

            this.$refs.contactForm.validate((valid) => {
                if (valid) {
                    updateUserInfo(this.form).then((res) => {
                        if (res.code) {
                            this.$message.success('添加成功');
                            this.dialogVisible = false;
                        }
                    });
                } else {
                    this.$message.error('请填写完整正确信息');
                }
            });
        }
    }
};
</script>


<style scoped>
.dialog-footer {
    text-align: right;
}
</style>
  